import { createSlice } from "@reduxjs/toolkit";
import { getEnquiries } from "./ThunkActions";
import { iEnquiryState, REDUCER_NAME } from "./Types";

const initialState: iEnquiryState = {
  isLoading: false,
  enquiryList: [],
  errorMessage: null,
};

export const enquirySlice = createSlice({
  name: REDUCER_NAME,
  initialState,
  reducers: {
    resetEnquiryState: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getEnquiries.pending, (state) => {
        state.isLoading = true;
        state.errorMessage = null;
      })
      .addCase(getEnquiries.fulfilled, (state, action) => {
        const payload = action.payload;
        if (payload && payload.data) {
          state.enquiryList = payload.data.data;
          state.isLoading = false;
        }
      })
      .addCase(getEnquiries.rejected, (state, action) => {
        state.errorMessage = "Failed to fetch enquiry data";
        state.isLoading = false;
      });
  },
});

export const { resetEnquiryState } = enquirySlice.actions;

export default enquirySlice.reducer;